export default {
  not_started: 'Määritä maksutilisi — tulo-osuutesi on jäädytetty, kunnes se on vahvistettu.',
  bank_account_missing: 'Lisää pankkitili maksuja varten — tulo-osuutesi on jäädytetty, kunnes teet niin.',
  incomplete: 'Maksutiliäsi ei ole vielä täysin vahvistettu — tulo-osuutesi on jäädytetty, kunnes se on.',
  add_bank_account: 'Lisää pankkitili',
  cta: 'Viimeistele asetukset',
};
